import React from 'react'
//import './styles.css'
//import './bootstrap.min.css'
import './spinner_styles.css'

export default function Spinner () {
  //return <Spinner animation="border" role="status"><span className="sr-only">Cargando...</span></Spinner>
  //return <div className="lds-ring"><div>Cargando...</div><div></div><div></div><div></div></div>
  return <div className="loader">Cargando...</div>
}